/* @flow */
import React from 'react';
// $FlowIgnore
import moment from 'moment';

import { TBody, Tr, Th, Td } from 'components/UIKit/Table';
import VerticalTable from './VerticalTable';
import Column from 'components/UIKit/Flex/Column';

export default function AnnotationsList({
  children
}: Object): React.Element {
  return (
    <Column>
    {children.map(ann => (
      <VerticalTable key={ann.submitter_id}>
        <TBody>
          <Tr><Th>Submitter ID</Th><Td>{ann.submitter_id}</Td></Tr>
          <Tr><Th>Category</Th><Td>{ann.category}</Td></Tr>
          <Tr><Th>Creator</Th><Td>{ann.creator}</Td></Tr>
          <Tr><Th>Updated Date</Th><Td>{moment(ann.updated_datetime).format('ll')}</Td></Tr>
          <Tr><Th>Notes</Th><Td>{ann.notes}</Td></Tr>
        </TBody>
      </VerticalTable>
    ))}
    </Column>
  );
}
